import type { ValueOf } from 'type-fest';

export const searchHintNames = {
  manual: 'manual',
  specialOffers: 'specialOffers',
  autoSelection: 'autoSelection',
  distributors: 'distributors',
  orders: 'orders',
  priceLists: 'priceLists',
  specialPriceLists: 'specialPriceLists',
  boundDrugs: 'boundDrugs',
  requirementsCalculation: 'requirementsCalculation',
  bindingNomenclature: 'bindingNomenclature',
  cart: 'cart',
  contractors: 'contractors',
  contractorAddresses: 'contractorAddresses',
  contractorContacts: 'contractorContacts',
  contractorUsers: 'contractorUsers',
  productUpdate: 'productUpdate',
  bonded: 'bonded',
  unbondedNomenclature: 'unbondedNomenclature',
  reconciliationNomenclature: 'reconciliationNomenclature',
} as const;

export type SearchHintName = ValueOf<typeof searchHintNames>;

export const localStorageNames = {
  searchHints: 'searchHints',
  useCartStore: 'useCartStore',
  dorimBaseTokens: 'dorim-base:tokens',
  dorimPriceTokens: 'dorim-price:tokens',
} as const;

export type SearchHintsLocalStorageScheme = Partial<Record<SearchHintName, string[] | undefined>>;

export interface LocalStorageScheme {
  [localStorageNames.searchHints]?: SearchHintsLocalStorageScheme;

  // TODO: change types
  [localStorageNames.useCartStore]?: any;
  [localStorageNames.dorimBaseTokens]?: string;
  [localStorageNames.dorimPriceTokens]?: string;
}

export const LOCAL_STORAGE_SCHEME: LocalStorageScheme = {};

export const SEARCH_HINT_MAX_COUNT = 5;
